<template>
    <div class="has-header">
        <div class="header main">
            <div class="align-left"></div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons" />
            </div>
            <div class="align-right"></div>
        </div>
        <div class="scrollbar-container">
            <div class="corset">
                <div class="mainheader split-bottom">{{ $t('store.roles.title') }}</div>
                <div class="half">
                    <div class="name-filter">
                        <i class="fas fa-search"></i>
                        <input class="filter-input" v-model="roleFilter"
                               :placeholder="this.$t('store.roles.filterRoles')"
                               v-on:input="roleFilter = SanitizeInput(roleFilter)" />
                    </div>
                    <div class="list">
                        <div class="list-entry" :key="index" v-for="(role, index) in rolesFilteredList"
                             v-on:click="ToggleRole($event, null, role)"
                             v-bind:class="{ selected: selectedRole === role }">
                            <div class="picture" v-bind:style="{ 'background-color': role.color }">
                                <strong>{{ role.letter }}</strong>
                            </div>
                            <div class="label">{{ role.name }}</div>
                            <div class="position-right">
                                <div class="picture text-center cursor-not-allowed" v-if="role.immutable">
                                    <i class="fas fa-lock fa-sm cursor-not-allowed"></i>
                                </div>
                                <div class="picture text-center" v-if="!role.immutable && role.id != ownRole"
                                     v-on:click="openDeleteModal(role)">
                                    <i class="fas fa-trash fa-sm"></i>
                                </div>
                            </div>
                            <div class="position-right">
                                <div class="picture text-center" v-if="!role.immutable"
                                     v-on:click="openEditModal(role)">
                                    <i class="fas fa-edit fa-sm"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="half">
                    <div class="name-filter">
                        <i class="fas fa-search"></i>
                        <input class="filter-input" v-model="userFilter"
                               :placeholder="this.$t('store.roles.filterUsers')" />
                    </div>
                    <div class="list" :class="anonMode ? 'anonblur' : ''">
                        <div class="list-entry" :key="index" v-for="(user, index) in usersFilteredList"
                             v-on:click="ToggleUser($event, null, user)"
                             v-bind:class="{ selected: user.highlighted }">
                            <div class="picture" v-bind:style="{ background: GetProfilePictureCSS(user) }"></div>
                            <div class="label">{{ user.name }} &nbsp;<small class="label-small">{{ user.email }}</small>
                            </div>
                            <div class="position-right">
                                <div class="picture text-center" v-bind:style="{ 'background-color': user.role.color }"
                                     v-if="user.role">
                                    <strong>{{ user.role.letter }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mainheader split-bottom">{{ $t('store.roles.permissions') }}</div>
                <div v-if="selectedRole">
                    <div :key="index" v-for="(domainGroup, index) in domainGroups" class="md-card-select">
                        <div class="subheader">{{ domainGroup.label }}</div>
                        <div :key="j" v-for="(ig, j) in domainGroup.domains"
                             v-bind:style="{width: 100 / domainGroup.domains.length + '%'}">
                            <div v-if="domainGroupMap[ig]"><h5 class="subheader2">{{ domainGroupMap[ig].label_de }}</h5>
                            </div>
                            <div v-if="domainGroupMap[ig]" :key="k"
                                 v-for="(perm, k) in permissionDomainMap[domainGroupMap[ig].key].filter((perm, k) => {return perm.id == 80 ? isSuperUser : true})"
                                 v-bind:class="{disabled:selectedRole ? (selectedRole.immutable && !(perm.id == 69 || (perm.id == 80 && isSuperUser))) : true}"
                                 class="cb-group">
                                <div class="label" style="width: 75%">{{ permissionTanslation[perm.name] }}</div>
                                <checkbox
                                    :disabled="selectedRole ? ((selectedRole.immutable && !(perm.id == 69 || (perm.id == 80 && isSuperUser))) || currentRoleHasPermissionMap[''+perm.id] ? currentRoleHasPermissionMap[''+perm.id].immutable : false) : true"
                                    :value="currentRoleHasPermissionMap[''+perm.id] ? currentRoleHasPermissionMap[''+perm.id].checked : false"
                                    :colorChecked="findColor(currentRoleHasPermissionMap[''+perm.id])"
                                    @Update="toggleRolePermission(perm.id)" style="float: right" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="discarder" v-if="modalAddUser" @click="modalAddUser = false"></div>
        <div class="md-card" v-if="modalAddUser">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('store.roles.addUser') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalAddUser = false"></i>
            </h6>
            <div class="md-card-body">
                <datatablesimple :state="availableEmpployeesState" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    components: {},
    name: 'StoreMain',
    data() {
        return {
            // FILTER VARIABLES
            roleFilter: '',
            userFilter: '',
            //LIST ARRAYS
            rolesList: [],
            usersList: [],
            availableUsersList: [],
            availableEmployeesList: [],
            //LIST ARRAYS FILTERED
            rolesFilteredList: [],
            usersFilteredList: [],

            //MAPS FOR LINKING STUFF
            roleMap: {},
            userMap: {},
            userRoleMap: {},
            permissionMap: {},
            rolePermissionMap: {},

            //HELPERS
            selectedRole: null,
            toDeleteRoleID: null,
            toEditRoleID: null,
            toCreateUserRoleAccountID: null,
            toCreateUserRoleRoleID: null,

            toDeleteUserRoleID: null,

            //CREATE/EDIT ELEMENTS
            newRolename: '',
            oldRolename: '',
            roleAlreadyExisting: false,

            //FIELDS FOR THE NEW USER TABLE
            domainGroups: [
                {
                    label: this.$t('store.roles.admin'),
                    domains: ['Role', 'StoreData', 'EmployeeTypeTemplateData', 'Statistics'],
                },
                { label: this.$tc('global.menubar.store', 1), domains: ['Structure', 'StoreEventData', 'ProjectData'] },
                {
                    label: this.$t('store.roles.finance'),
                    domains: ['PlanningData', 'PlanningEmployeeThreshold', 'CrewLaborPlanning'],
                },
                {
                    label: this.$t('store.roles.payroll'),
                    domains: ['ReportData', 'EmployeeWorkBalance', 'PreferenceData'],
                },
                {
                    label: this.$t('store.roles.hr'),
                    domains: ['EmployeeData', 'EmployeeFile', 'AvailabilityData', 'EmployeeSkillData', 'AppInfo'],
                },
                {
                    label: this.$t('store.roles.ops'),
                    domains: ['ShiftData', 'ShiftTemplateData', 'RosterData', 'Notification'],
                },

            ],
            permissionTanslation: {
                'Read': this.$t('store.roles.read'),
                'ReadMarket': this.$t('store.roles.readMarket'),
                'Write': this.$t('store.roles.write'),
                'Update': this.$t('store.roles.update'),
                'Delete': this.$t('store.roles.delete'),
                'Confirm': this.$t('store.roles.confirm'),
                'Unconfirm': this.$t('store.roles.unConfirm'),
                'Send': this.$t('store.roles.send'),
                'IgnoreLaw': this.$t('store.roles.ignoreLaw'),
                'UpdateSpecialFields': this.$t('store.roles.updateSpecialFields'),
                'LinkAccount': this.$t('store.roles.linkAccount')
            },

            modalAddUser: false,
        };
    },
    watch: {
        roleFilter: function(val, oldVal) {
            this.filterRoles();
        },
        userFilter: function(val, oldVal) {
            this.filterUsers();
        },
        newRolename: function(val, oldVal) {
            this.checkRoleExisting();
        },
        storeId: function(val, oldVal) {
            this.refresh();
        },
    },
    computed: {
        ...mapGetters(['storeId', 'uiDataMap', 'userInfo', 'isSuperUser', 'anonMode']),
        ownRole() {
            let accId = this.userInfo.id;

            let roles = Object.values(this.userRoleMap).filter(i => i.accountId == accId);

            let result = null;
            if (roles.length > 0) {
                result = roles[0].role.id;
            }
            return result;
        },
        currentRoleHasPermissionMap() {
            let map = {};
            const role = this.selectedRole;
            let rperms = role ? this.roleRolePermissionMap[role.id] ? this.roleRolePermissionMap[role.id] : [] : [];
            Object.values(this.permissionMap).forEach(perm => {
                let rperm = rperms.find(item => item.permissionId == perm.id);
                if (rperm) {
                    console.log(rperm.level);
                    map['' + perm.id] = { level: rperm.level, immutable: rperm.immutable, checked: true };
                } else {
                    map['' + perm.id] = { level: 0, immutable: false, checked: false };
                }
            });

            return map;
        },
        permissionDomainMap() {
            let map = {};
            Object.values(this.permissionMap).forEach(perm => {
                if (!map[perm.domain]) {
                    map[perm.domain] = [];
                }
                map[perm.domain].push(perm);
            });

            return map;
        },
        roleRolePermissionMap() {
            let map = {};
            Object.values(this.rolePermissionMap).forEach(rperm => {
                if (!map[rperm.roleId]) {
                    map[rperm.roleId] = [];
                }
                map[rperm.roleId].push(rperm);
            });
            return map;
        },
        domainGroupMap() {
            let map = {};
            this.uiDataMap.permissionDomains.forEach(d => {
                map[d.key] = d;
            });
            return map;
        },
        headerButtons() {

            let view = this;
            let helperLinks = [];
            let buttons = [
                {
                    type: 'block',
                    icon: 'fa-refresh',
                    click: () => {
                        view.refresh(true);
                    },
                    tooltip: this.$t('global.menubar.store'),
                },
                {
                    classes: 'add-role',
                    type: 'block green border-r',
                    disabled: false,
                    icon: 'fa-key',
                    click: () => {
                        this.openNewRoleWizard();
                    },
                    show: true,
                    tooltip: this.$t('store.roles.addRole'),
                    helperText:
                        this.$t('store.roles.addRoleHelp'),
                    externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1967882241',
                },
                {
                    classes: 'add-user',
                    type: 'block green',
                    disabled: false,
                    icon: 'fa-user-plus',
                    click: () => {
                        this.modalAddUser = true;
                    },
                    show: true,
                    tooltip: this.$t('store.roles.addUser'),
                    helperText:
                        this.$t('store.roles.addUserHelp'),
                    externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/1967882241',
                },
            ];
            if (this.isSuperUser) {
                buttons.push({
                    classes: 'add-user',
                    type: 'block orange',
                    disabled: false,
                    icon: 'fa-key',
                    click: () => {
                        this.createBaseRoles();
                    },
                    show: true,
                    tooltip: this.$t('store.roles.addDefaultRoles'),
                    helperText: '',
                });
            }

            let state = {
                buttons: buttons,
                helperLinks: helperLinks,
                showListIconAlways: true,
            };

            state.helperLinks = [
                {
                    icon: 'fa-video',
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: 'https://www.youtube.com/watch_popup?v=ES15Y5i5vKU',
                    externalLabel: this.$t('store.structure.watchTrainingVideoLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                {
                    title: this.$t('store.structure.getSupport'),
                    helperText: this.$t('store.structure.getSupportHelp'),
                    externalUrl:
                        'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16',
                    externalLabel: this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
            ];
            return state;
        },
        availableEmpployeesState() {
            if (!this.availableEmployeesList) {
                return null;
            }

            let view = this;

            let state = {};

            let columns = {};
            columns.pic = ' ';
            columns.name = this.$t('pages.employeeData.name');
            columns.email = this.$t('pages.employeeCoreData.email');
            columns.actions = ' ';

            let data = Object.values(this.availableEmployeesList);

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'pic');
            state.headerMap.pic.componentStateBuilders = [(data) => {
                return {
                    componentType: 'employeepicture',
                    pictureUrl: this.GetProfilePicture(data),
                    styleLabel: view.$helpers.styleLabel,
                };
            }];


            view.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
            state.headerMap.name.sort = true;
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'email');
            state.headerMap.email.sort = true;

            // Actions
            state.headerMap.actions.stylesEntry = { 'justify-content': 'left' };
            state.headerMap.actions.componentStateBuilders = [
                (data, entry) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('store.roles.addEmployee');
                        },
                        disabled: false,
                        type: 'button icon-overlay square',
                        icon: 'fa-plus',
                        styleButton: { margin: '0 2px 0 2px' },
                        customEvents: {
                            click: (event) => {
                                view.linkEmployee(event, data);
                            },
                        },
                    };
                },
            ];

            let entries = Object.entries(state.headerMap);

            let mainColumnWidth = 40;
            let mainColumns = ['name', 'email'];

            let actionColumns = ['actions', 'pic'];
            let actionColumnWidth = 10;
            for (let x in entries) {
                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = { fontSize: '10px', position: 'sticky', top: 0, zIndex: 10 };
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = { fontSize: '10px' };
            state.alwaysUnfold = false;
            return state;
        },
    },
    props: {},
    created() {
        window.roles = this;
    },
    mounted() {
        this.seconds = new Date().getTime() / 1000;
        let view = this;
        view.refresh();
    },

    updated() {
    },
    destroyed() {
    },

    methods: {
        findColor(val) {
            if (!val) return null;
            if (val.level === 1) return 'var(--col-info)';
            if (val.level === 2) return 'orange';
            return null;
        },
        filterRoles() {
            if (this.roleFilter === '') {
                this.rolesFilteredList = this.rolesList.slice();
                return;
            }
            this.rolesFilteredList = this.rolesList.filter(
                (e) =>
                    e.name.toUpperCase().indexOf(this.roleFilter.toUpperCase()) > -1 ||
                    e.id == (this.selectedRole && this.selectedRole.id),
            );
        },
        filterUsers() {
            if (this.userFilter === '') {
                this.usersFilteredList = this.usersList.slice();
                return;
            }
            this.usersFilteredList = this.usersList.filter(
                (e) =>
                    e.name.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1 ||
                    e.email.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1,
            );
        },
        filterFilteredUsers() {
            if (this.userFilter === '') {
                this.usersFilteredList = this.usersFilteredList.slice();
                return;
            }
            this.usersFilteredList = this.usersFilteredList.filter(
                (e) =>
                    e.name.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1 ||
                    e.email.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1,
            );
        },
        sortByName: function(a, b) {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
            return 0;
        },
        checkRoleExisting() {
            this.roleAlreadyExisting = false;
            for (let i = 0; i < this.rolesList.length; i++) {
                if (
                    this.rolesList[i].name.toUpperCase() == this.newRolename.toUpperCase()
                ) {
                    this.roleAlreadyExisting = true;
                    return;
                }
            }
        },

        SanitizeInput(input) {
            input = input.replace(/[^A-Za-z0-9 \-]/g, '');
            if (input.length > 32) {
                input = input.substring(0, 32);
            }
            return input;
        },

        hideModal(ref) {
            this.$refs[ref].hide();
        },
        showModal(ref) {
            this.$refs[ref].show();
        },
        openNewRoleWizard() {
            let view = this;

            let dataEntries = [];
            dataEntries.push({ label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text' });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: null,
                    selectCallback: function(data) {
                        view.createRole(data.name);
                    },
                },
                header: this.$t('store.roles.addRole'),
                expanded: true,
                centered: true,
            });
        },
        openEditModal: function(role) {
            let view = this;
            let dataEntries = [];
            dataEntries.push({ label: 'Id', key: 'id', hidden: true, type: 'text', value: role.id });
            dataEntries.push({
                label: this.$t('pages.employeeData.name'),
                key: 'name',
                hidden: false,
                type: 'text',
                value: role.name,
            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: null,
                    selectCallback: function(data) {
                        view.updateRole(data);
                    },
                },
                header: this.$t('store.roles.editRole'),
                expanded: true,
                centered: true,
            });
        },
        openDeleteModal: function(role) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('store.roles.deleteRole'),
                description: this.$t('store.roles.deleteRoleQuery'),
                callbackAccept: function(popup) {
                    view.deleteRole(role.id);
                    popup.hidden = true;
                }, callbackCancel: function(popup) {
                    popup.loading = false;
                    popup.hidden = true;
                },
            });
        },

        ToggleRole($event, component, role) {
            if (this.selectedRole === role) {
                this.selectedRole = null;
            } else {
                this.selectedRole = role;
            }

            for (let i = 0; i < this.usersList.length; i++) {
                if (
                    this.selectedRole != null &&
                    this.usersList[i].role &&
                    this.usersList[i].role.id != null &&
                    this.selectedRole.id == this.usersList[i].role.id
                ) {
                    this.usersList[i].highlighted = true;
                } else {
                    this.usersList[i].highlighted = false;
                }
            }
            this.OrderUsersBySelectedRole(0);
        },
        ToggleUser($event, component, user) {
            let view = this;
            if (this.selectedRole == null) {
                this.$helpers.warning(
                    this.$t('store.roles.inputError'),
                    this.$t('store.roles.selectRole'),
                );
            } else if (this.selectedRole.type == 0) {
                if (this.isSuperUser) {
                    window.app.popupalerts.push({
                        header: this.$t('store.roles.transferRoleOwner'),
                        description: this.$t('store.roles.transferRoleOwnerQuery'),
                        hidden: false,
                        callbackAccept: function(popup) {
                            popup.loading = true;
                            view.toCreateUserRoleAccountID = user.accountId;
                            view.toCreateUserRoleRoleID = view.selectedRole.id;
                            view.replaceOwnerRole();
                            popup.loading = false;
                            popup.hidden = true;
                        },
                        callbackCancel: function(popup) {
                            popup.loading = false;
                            popup.hidden = true;

                        },
                    });
                } else {
                    this.$helpers.warning(
                        this.$t('store.roles.inputError'),
                        this.$t('store.roles.cantChangeOwner'),
                    );
                }

            } else if (user.role && user.role.type == 0) {
                this.$helpers.warning(
                    this.$t('store.roles.inputError'),
                    this.$t('store.roles.cantChangeOwner'),
                );
            } else if (user.role && user.immutable) {
                this.$helpers.warning(
                    this.$t('store.roles.inputError'),
                    this.$t('store.roles.cantChangeUser'),
                );
            } else if (
                user.accountId == this.userInfo.id
            ) {
                this.$helpers.warning(
                    this.$t('store.roles.inputError'),
                    'this.$t(\'store.roles.cantChangeSelf\')',
                );
            } else if (user.role == null || this.selectedRole.id != user.role.id) {
                let roleName = this.roleMap[this.selectedRole.id] ? this.roleMap[this.selectedRole.id].name : '-';
                let userName = user.name ? user.name : '-';
                window.app.popupalerts.push({
                    header: this.$t('store.roles.assignRole'),
                    description: this.$t('store.roles.assignRoleQuery', [userName, roleName]),
                    hidden: false,
                    callbackAccept: function(popup) {
                        popup.loading = true;
                        view.toCreateUserRoleAccountID = user.accountId;
                        view.toCreateUserRoleRoleID = view.selectedRole.id;
                        view.createUserRole();
                        popup.loading = false;
                        popup.hidden = true;
                    },
                    callbackCancel: function(popup) {
                        popup.loading = false;
                        popup.hidden = true;

                    },
                });

            } else if (this.selectedRole.id == user.role.id) {
                let roleName = this.roleMap[this.selectedRole.id] ? this.roleMap[this.selectedRole.id].name : '-';
                let userName = user.name ? user.name : '-';
                window.app.popupalerts.push({
                    header: this.$t('store.roles.removeRole'),
                    description: this.$t('store.roles.removeRoleQuery', [roleName, userName]),
                    hidden: false,
                    callbackAccept: function(popup) {
                        popup.loading = true;
                        view.toDeleteUserRoleID = user.userRoleID;
                        view.deleteUserRole();
                        popup.loading = false;
                        popup.hidden = true;
                    },
                    callbackCancel: function(popup) {
                        popup.loading = false;
                        popup.hidden = true;

                    },
                });

            }
        },

        OrderUsersBySelectedRole(filtermethod) {
            this.usersList.sort(this.sortByName); // Maybe not needed, if it's already sorted
            let helperSelected = [];
            let helperNotSelected = [];
            let newArray = this.usersList.slice();
            let j = 0;
            let jj = 0;
            if (this.selectedRole != null) {
                newArray = [];
                for (let i = 0; i < this.usersList.length; i++) {
                    if (
                        this.usersList[i].role &&
                        this.usersList[i].role.id == this.selectedRole.id
                    ) {
                        helperSelected[j++] = this.usersList[i];
                    } else {
                        helperNotSelected[jj++] = this.usersList[i];
                    }
                }
                newArray = helperSelected.concat(helperNotSelected);
                this.usersList = newArray.slice();
                this.usersFilteredList = newArray.slice();
            }
            if (filtermethod == 0 ? this.filterUsers() : this.filterFilteredUsers()) ;
            this.$forceUpdate();
        },

        refresh() {
            let view = this;

            this.selectedRole = null;
            this.toDeleteRoleID = null;
            this.toEditRoleID = null;
            this.toCreateUserRoleAccountID = null;
            this.toCreateUserRoleRoleID = null;
            this.toDeleteUserRoleID = null;
            this.newRolename = '';
            this.oldRolename = '';
            this.roleAlreadyExisting = false;
            this.$helpers.GetUiDataMap().then(map => {
                return view.loadRoles();
            })
                .then((response) => {
                    view.updateRoles(response.data);
                    view.filterRoles();
                    return view.loadUsers();
                })
                .then((response) => {
                    view.updateUsers(response.data);
                    return view.loadUserRoles();
                })
                .then((response) => {
                    view.updateUserRoles(response.data);
                    return view.loadPermissions();
                })
                .then((response) => {
                    view.permissionMap = view.updatePermissionMap(response.data);
                    return view.loadRolePermissions();
                })
                .then((response) => {
                    view.rolePermissionMap = view.updateRolePermissionMap(response.data);
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                });
        },

        updateRoles(data) {
            let overviewA = [];
            let map = {};
            for (let i = 0; i < data.length; i++) {
                //if(data[i].name.toLowerCase() != 'user'){
                let roleItem = {
                    id: data[i].id,
                    name: data[i].name,
                    immutable: data[i].immutable,
                    active: data[i].active,
                    type: data[i].type,
                    letter: data[i].name.charAt(0).toUpperCase(),
                    //color: "#"+roles.intToRGB(roles.hashCode(data[i].name)),
                    color: 'var(--contrast-1)',
                };
                if (data[i].name.toLowerCase() == 'user') {
                    roleItem.active = false;
                }
                map[data[i].id] = roleItem;
                overviewA.push(roleItem);
                //}
            }
            this.roleMap = map;
            this.rolesList = overviewA;
            this.rolesList.sort(this.sortByName);
            this.rolesFilteredList = this.rolesList.slice();
            this.$forceUpdate();
        },

        updateUsers(data) {
            let overviewUsers = [];
            let overviewEmployees = [];
            let map = {};
            for (let i = 0; i < data.length; i++) {
                let user = {
                    accountId: data[i].accountId,
                    employeeId: data[i].employeeId,
                    name: data[i].firstName + ' ' + data[i].lastName,
                    firstname: data[i].firstName,
                    lastname: data[i].lastName,
                    profileImage: data[i].profileImage,
                    email: data[i].email,
                    type: data[i].type,
                };

                if (data[i].accountId != null) {
                    map[data[i].accountId] = user;
                    overviewUsers.push(user);
                } else {
                    overviewEmployees.push(user);
                }
            }
            this.userMap = map;
            this.usersList = overviewUsers;
            this.usersList.sort(this.sortByName);
            this.usersFilteredList = this.usersList.slice();

            this.availableEmployeesList = overviewEmployees;
            this.availableEmployeesList.sort(this.sortByName);
            this.$forceUpdate();
        },

        updateUserRoles(data) {
            let overviewA = [];
            let map = {};
            for (let i = 0; i < data.length; i++) {
                if (
                    this.userMap[data[i].accountId] !=
                    undefined /*&& this.roleMap[data[i].roleId] != undefined*/
                ) {
                    let userRoleItem = {
                        id: data[i].id,
                        accountId: data[i].accountId,
                        immutable: data[i].immutable,
                        role: this.roleMap[data[i].roleId],
                    };
                    map[data[i].id] = userRoleItem;
                    overviewA.push(userRoleItem);
                }
            }

            for (let i = 0; i < this.usersList.length; i++) {
                for (let j = 0; j < overviewA.length; j++) {
                    if (overviewA[j].accountId == this.usersList[i].accountId) {
                        this.usersList[i].userRoleID = overviewA[j].id;
                        this.usersList[i].immutable = overviewA[j].immutable;
                        this.usersList[i].role = overviewA[j].role;
                    }
                }
            }
            this.userRoleMap = map;
            this.usersFilteredList = this.usersList.slice();
            this.$forceUpdate();
        },
        createBaseRoles: function() {
            let view = this;
            let url = '/api/sec/role/baseroles';
            let params = {
                storeId: this.$store.state.storeId,
            };

            let payload = {
                storeId: this.$store.state.storeId,
            };

            this.axios({
                method: 'post',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            })
                .then((response) => {
                    view.refresh();
                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('store.roles.defaultRolesAdded'));
                })
                .catch(function(error) {
                    //view.error=true;
                    console.log(error);
                });
        },
        toggleRolePermission(permId) {
            let rolePermissionId = null;
            let roleId = this.selectedRole ? this.selectedRole.id : null;

            if (this.roleRolePermissionMap[roleId]) {
                let rolePermission = this.roleRolePermissionMap[roleId].find((item) => item.permissionId == permId);
                if (rolePermission) {
                    rolePermissionId = rolePermission.id;
                }
            }
            if (roleId && !rolePermissionId) {
                //create
                if (permId == 9) { //employeedata read
                    this.openEmployeeDataModal(roleId, permId);
                } else if (permId == 12) { //employeedata delete
                    this.openEmployeeDataDeleteModal(roleId, permId);
                } else if (permId == 13) { //shiftdata read
                    this.openShiftDataModal(roleId, permId);
                } else if (permId == 81) { //employeefile read
                    this.openEmployeeFileModal(roleId, permId);
                } else if (permId == 26 || permId == 27) { //employeepreference create & update
                    this.openEmployeePreferenceModal(roleId, permId);
                } else {
                    this.createRolePermission(roleId, permId);
                }

            } else if (roleId && rolePermissionId) {
                //delete
                this.deleteRolePermission(rolePermissionId);
            }
        },
        openEmployeePreferenceModal: function(roleId, permId) {
            let view = this;
            let dataEntries = [];
            dataEntries.push({
                label: this.$t('store.roles.dataAccess'), key: 'level', type: 'dropdownsearch',
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectFirst: true,
                    items: [
                        { label: this.$t('store.roles.prefPermAll'), value: 3 },
                        { label: this.$t('store.roles.prefPermLimited'), value: 2 },
                    ],
                },

            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: null,
                    selectCallback: function(data) {
                        view.createRolePermission(roleId, permId, data.level != null ? data.level : 3);

                    },
                },
                header: this.$t('store.roles.prefPermData'),
                expanded: true,
                centered: true,
            });
        },
        openEmployeeDataModal: function(roleId, permId) {
            let view = this;
            let dataEntries = [];
            dataEntries.push({
                label: this.$t('store.roles.dataAccess'), key: 'level', type: 'dropdownsearch',
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectFirst: true,
                    items: [
                        { label: this.$t('store.roles.accessAllData'), value: 3 },
                        { label: this.$t('store.roles.accessBaseContact'), value: 2 },
                        { label: this.$t('store.roles.accessBaseData'), value: 1 },
                    ],
                },

            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: null,
                    selectCallback: function(data) {
                        view.createRolePermission(roleId, permId, data.level != null ? data.level : 3);

                    },
                },
                header: this.$t('store.roles.sensitiveEmployeeData'),
                expanded: true,
                centered: true,
            });
        },
        openEmployeeFileModal: function(roleId, permId) {
            let view = this;

            let dataEntries = [];
            dataEntries.push({
                label: this.$t('store.roles.dataAccess'), key: 'level', type: 'dropdownsearch',
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectFirst: true,
                    items: [
                        { label: this.$t('store.roles.accessAllDocuments'), value: 3 },
                        { label: this.$t('store.roles.accessNonSensitiveData'), value: 2 },
                        { label: this.$t('store.roles.accessBaseData'), value: 1 },
                    ],
                },

            });


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: null,
                    selectCallback: function(data) {
                        view.createRolePermission(roleId, permId, data.level != null ? data.level : 3);

                    },
                },
                header: this.$t('store.roles.employeeDocuments'),
                width: '700px',
                expanded: true,
                centered: true,
            });
        },
        openShiftDataModal: function(roleId, permId) {
            let view = this;
            let dataEntries = [];
            dataEntries.push({
                label: this.$t('store.roles.dataAccess'), key: 'level', type: 'dropdownsearch',
                dropdownSearchState: {
                    selectMultiple: false, styleLight: true,
                    selectFirst: true,
                    items: [
                        { label: this.$t('store.roles.accessAllShiftData'), value: 3 },
                        { label: this.$t('store.roles.accessAllExceptApp'), value: 2 },
                        { label: this.$t('store.roles.accessPublishedApp'), value: 1 },
                    ],
                },

            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: null,
                    selectCallback: function(data) {
                        view.createRolePermission(roleId, permId, data.level != null ? data.level : 3);

                    },
                },
                header: this.$t('store.roles.shiftData'),
                expanded: true,
                centered: true,
                width: '600px',
            });
        },

        openEmployeeDataDeleteModal: function(roleId, permId) {
            let view = this;
            let dataEntries = [];
            dataEntries.push({
                label: this.$t('store.roles.deleteEmployeeUtterlyQuery'),
                key: 'sensitiveData',
                hidden: false,
                type: 'bool',
                value: false,
            });


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: null,
                    selectCallback: function(data) {
                        if (data.sensitiveData) {
                            view.createRolePermission(roleId, permId);
                        } else {
                            view.createRolePermission(roleId, permId, 2);
                        }

                    },
                },
                header: this.$t('store.roles.deleteEmployeeCompletely'),
                expanded: true,
                centered: true,
            });
        },
        createRolePermission: function(roleId, permissionId, level = 3) {

            let view = this;
            let url = '/api/sec/rolepermission';
            let params = {
                storeId: this.$store.state.storeId,
            };

            let payload = {
                roleId: roleId,
                permissionId: permissionId,
                level: level,
            };

            this.axios({
                method: 'post',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            })
                .then((response) => {
                    view.rolePermissionMap[response.data.data.id] = response.data.data;
                    view.rolePermissionMap = Object.assign({}, view.rolePermissionMap);

                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('store.roles.permissionAssigned'));
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.roles.permissionAssignedError'));
                    console.log(error);
                });
        },
        deleteRolePermission: function(rolePermissionId) {

            let view = this;
            let url = '/api/sec/rolepermission';
            let params = {
                storeId: this.$store.state.storeId,
                id: rolePermissionId,
            };


            this.axios({
                method: 'delete',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
            })
                .then((response) => {
                    delete view.rolePermissionMap[rolePermissionId];
                    view.rolePermissionMap = Object.assign({}, view.rolePermissionMap);

                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('store.roles.permissionRemoved'));
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.roles.permissionRemovedError'));
                    console.log(error);
                });
        },
        createRole: function(roleName) {

            let view = this;
            let url = '/api/sec/role';
            let params = {
                storeId: this.$store.state.storeId,
            };

            let payload = {
                storeId: this.$store.state.storeId,
                name: roleName,
            };

            this.axios({
                method: 'post',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            })
                .then((response) => {

                    let letter = response.data.data.name.charAt(0).toUpperCase();
                    let roleItem = {
                        id: response.data.data.id,
                        name: response.data.data.name,
                        immutable: response.data.data.immutable,
                        active: response.data.data.active,
                        letter: letter,
                        /*color: "#"+roles.intToRGB(roles.hashCode(response.data[i].name)),*/
                        color: 'var(--contrast-1)',
                    };

                    view.roleMap[response.data.data.id] = roleItem;
                    view.rolesList.push(roleItem);
                    
                    view.rolesFilteredList = view.rolesList.slice();
                    view.filterRoles();
                    view.$forceUpdate();

                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('store.roles.roleCreated'));
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.roles.roleCreatedError'));
                    console.log(error);
                });
        },
        updateRole: function(role) {


            let view = this;
            let url = '/api/sec/role';
            let params = {
                storeId: this.$store.state.storeId,
            };

            let payload = {
                storeId: this.$store.state.storeId,
                id: role.id,
                name: role.name,
                updateFields: ['name'],
            };


            this.axios({
                method: 'put',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                data: payload,
                params: params,
            })
                .then((response) => {
                    view.refresh();

                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.roles.roleEdited'));
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.roles.roleEditedError'));
                    console.log(error);
                });
        },
        deleteRole: function(roleId) {
            let view = this;
            let url = '/api/sec/role';
            let params = {
                storeId: this.$store.state.storeId,
                id: roleId,
            };


            this.axios({
                method: 'delete',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
            })
                .then((response) => {
                    const index = this.rolesList.findIndex(
                        (role) => role.id === roleId,
                    );
                    if (view.selectedRole && view.selectedRole.id == roleId) {
                        view.selectedRole = null;
                    }
                    if (~index) {
                        view.rolesList.splice(index, 1);
                        view.rolesFilteredList = view.rolesList.slice();
                    }
                    view.deleteRoleFromMap(roleId);

                    this.$helpers.success(this.$t('global.notifications.success'), 'Rolle wurde erfolgreich gelöscht!');
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Löschen der Rolle!');
                    console.log(error);
                });
        },
        linkEmployee: function(evt, data) {
            evt.preventDefault();
            //this.employeeerror=false;
            let view = this;

            for (let i = 0; i < view.availableEmployeesList.length; i++) {
                if (data.employeeId == view.availableEmployeesList[i].employeeId) {
                    view.availableEmployeesList[i].loading = true;
                }
            }
            view.$forceUpdate();

            let url = '/api/sec/employee/linkaccount';
            url = this.$helpers.appendParam(
                'storeId',
                this.$store.state.storeId,
                url,
                '/api/sec/employee/linkaccount',
            );
            url = this.$helpers.appendParam(
                'id',
                data.employeeId,
                url,
                '/api/sec/employee/linkaccount',
            );

            this.axios({
                method: 'put',
                headers: {
                    AUTHORIZATION: 'bearer ' + this.$store.state.jwt,
                },
                url: url,
            })
                .then((response) => {
                    data.accountId = response.data.data;
                    view.usersList.push(data);
                    view.usersList.sort(view.sortByName);
                    view.filterUsers();

                    for (let i = 0; i < view.availableEmployeesList.length; i++) {
                        if (
                            data.employeeId == view.availableEmployeesList[i].employeeId
                        ) {
                            view.availableEmployeesList.splice(i, 1);
                        }
                    }
                    this.$helpers.success(
                        this.$t('global.notifications.success'),
                        this.$t('store.roles.accountLinked'),
                    );
                })
                .catch(function(error) {
                    //view.employeeerror=true;
                    console.log(error);
                });
        },
        replaceOwnerRole: function() {
            let view = this;
            let url = '/api/sec/userrole/replaceowner';
            url = this.$helpers.appendParam(
                'storeId',
                this.$store.state.storeId,
                url,
                '/api/sec/userrole/replaceowner',
            );

            let payload = {
                accountId: this.toCreateUserRoleAccountID,
                roleId: this.toCreateUserRoleRoleID,
            };

            this.axios({
                method: 'post',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                data: payload,
            })
                .then((response) => {

                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.roles.roleAssigned'));
                    view.refresh(true);
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.roles.roleAssignedError'));
                    console.log(error);
                });
        },
        createUserRole: function() {
            let view = this;
            let url = '/api/sec/userrole';
            url = this.$helpers.appendParam(
                'storeId',
                this.$store.state.storeId,
                url,
                '/api/sec/userrole',
            );

            let payload = {
                accountId: this.toCreateUserRoleAccountID,
                roleId: this.toCreateUserRoleRoleID,
            };

            this.axios({
                method: 'post',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                data: payload,
            })
                .then((response) => {
                    let data = response.data.data;
                    let userRoleItem = {
                        id: data.id,
                        accountId: data.accountId,
                        immutable: data.immutable,
                        role: view.roleMap[data.roleId],
                    };
                    view.userRoleMap[data.id] = userRoleItem;

                    for (let i = 0; i < view.usersList.length; i++) {
                        if (data.accountId == view.usersList[i].accountId) {
                            view.usersList[i].userRoleID = data.id;
                            view.usersList[i].immutable = data.immutable;
                            view.usersList[i].role = view.roleMap[data.roleId];
                            view.usersList[i].highlighted = true;
                        }
                    }
                    view.$forceUpdate();
                    view.OrderUsersBySelectedRole(1);
                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('store.roles.roleAssigned'));
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.roles.roleAssignedError'));
                    console.log(error);
                });
        },
        deleteUserRole: function() {
            let view = this;
            let url = '/api/sec/userrole';
            url = this.$helpers.appendParam(
                'id',
                this.toDeleteUserRoleID,
                url,
                '/api/sec/userrole',
            );
            url = this.$helpers.appendParam(
                'storeId',
                this.$store.state.storeId,
                url,
                '/api/sec/userrole',
            );

            this.axios({
                method: 'delete',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
            })
                .then((response) => {
                    for (let i = 0; i < view.usersList.length; i++) {
                        if (view.toDeleteUserRoleID == view.usersList[i].userRoleID) {
                            view.usersList[i].userRoleID = null;
                            view.usersList[i].immutable = null;
                            view.usersList[i].role = null;
                            view.usersList[i].highlighted = false;
                        }
                    }
                    view.$forceUpdate();
                    view.OrderUsersBySelectedRole(1);

                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('store.roles.roleRemoved'));
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.roles.roleRemovedError'));
                    console.log(error);
                });
        },

        deleteRoleFromMap(id) {
            let key = null;
            /*for(key in this.rolePermissionMap){
                  if(this.rolePermissionMap[key].roleId === id){
                      this.deleteRolePermissionFromMap(key);
                  }
              }*/
            for (key in this.userRoleMap) {
                if (this.userRoleMap[key].roleId === id) {
                    this.deleteUserRoleFromMap(key);
                }
            }
            delete this.roleMap[id];
        },
        deleteRolePermissionFromMap(id) {
            delete this.rolePermissionMap[id];
        },
        deleteUserRoleFromMap(id) {
            delete this.userRoleMap[id];
        },
        loadRoles() {
            let url = '/api/sec/role';
            url = this.$helpers.appendParam(
                'storeId',
                this.$store.state.storeId,
                url,
                '/api/sec/role',
            );
            return this.axios({
                method: 'get',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
            });
        },
        loadPermissions() {
            let url = '/api/sec/permission';
            let params = {
                storeId: this.$store.state.storeId,
            };
            return this.axios({
                method: 'get',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
            });
        },
        updatePermissionMap(data) {
            let map = {};
            data.forEach((permission) => {
                map[permission.id] = permission;
            });
            return map;
        },
        loadRolePermissions() {
            let url = '/api/sec/rolepermission';
            let params = {
                storeId: this.$store.state.storeId,
            };
            return this.axios({
                method: 'get',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
            });
        },
        updateRolePermissionMap(data) {
            let map = {};
            data.forEach((rperm) => {
                map[rperm.id] = rperm;
            });
            return map;
        },
        loadUsers() {
            let url = '/api/sec/user';
            url = this.$helpers.appendParam(
                'storeId',
                this.$store.state.storeId,
                url,
                '/api/sec/user',
            );
            url = this.$helpers.appendParam(
                'companyId',
                this.$store.state.companyId,
                url,
                '/api/sec/user',
            );
            return this.axios({
                method: 'get',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
            });
        },
        loadUserRoles() {
            let url = '/api/sec/userrole';
            url = this.$helpers.appendParam(
                'storeId',
                this.$store.state.storeId,
                url,
                '/api/sec/userrole',
            );
            return this.axios({
                method: 'get',
                headers: {
                    AUTHORIZATION: 'Bearer ' + this.$store.state.jwt,
                },
                url: url,
            });
        },

        GetProfilePictureCSS(user) {
            if (!user.profileImage)
                return 'var(--contrast-1) no-repeat center/cover  url(https://fileserver1.meindienstplan.de:8443/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S)';
            return (
                'var(--contrast-1) no-repeat center/cover  url(' +
                user.profileImage +
                ')'
            );
        },
        GetProfilePicture(user) {
            if (!user.profileImage)
                return 'https://fileserver1.meindienstplan.de:8443/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S';
            return user.profileImage;
        },
        hashCode(str) {
            // java String#hashCode
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            return hash;
        },
        intToRGB(i) {
            let c = (i & 0x00ffffff).toString(16).toUpperCase();

            return '00000'.substring(0, 6 - c.length) + c;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.name-filter .fa-search {
    color: var(--contrast-4);
    position: absolute;
    top: 5px;
    left: 5px;
}

.half-width {
    width: 50%;
}

.fix-button-width {
    width: 150px;
}

.filter-input {
    margin-left: -35px;
    padding-left: 40px;
    width: calc(100% - 25px);
}

.list {
    margin-left: 5px;
    width: calc(100% - 25px);
    height: 265px;
    box-shadow: inset 0 0 0 1px var(--contrast-3);
    overflow-x: hidden;
    overflow-y: auto;
    border-radius: 5px;
}

.list-entry {
    height: 35px;
    margin-bottom: 2px;
    border-radius: 100px;
    cursor: pointer;
}

.list-entry:hover {
    background: var(--sub-menu);
    cursor: pointer;
}

.list-entry.selected {
    background: #6d8d23;
    cursor: pointer;
}

.list-entry.selected > .label,
.list-entry:hover > .label {
    color: var(--bg);
    cursor: pointer;
}

.list-entry.selected > .label > .label-small,
.list-entry.hover > .label > .label-small {
    color: var(--bg) !important;
    cursor: pointer;
}

.list-entry > .label {
    float: left;
    font-size: 14px;
    font-family: DistrictProBook;
    color: var(--contrast-4);
    padding-top: 6px;
    cursor: pointer;
}

.list-entry > .label > .label-small {
    cursor: pointer;
    color: var(--contrast-5);
}

.picture {
    float: left;
    border-radius: 100px;
    background: var(--contrast-1);
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 10px;
    height: 25px;
    width: 25px;
}

.position-right {
    float: right;
    margin: 0;
    margin-right: -5px;
}

.pictureImg {
    border-radius: 100px;
    height: 25px;
    width: 25px;
}

/* width */
::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
    background: var(--contrast-1);
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: var(--contrast-3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #aaaaaa;
}

.scrollbar-container {
    display: flex;
    padding: 5px 20px;
    justify-content: center;
}

.corset {
    max-width: 1140px;
}

.mainheader {
    margin: 10px 0 0 0;

    width: 100%;
    height: 56px;
    color: var(--md);
    float: left;
    text-align: left;
    font-size: 32px;
    font-family: DistrictProBook, serif;
}

.subheader {
    color: var(--md);
    font-size: 24px;
    font-family: DistrictProBold, serif;
    font-weight: 700;
    width: 100%;
    height: 44px;
    text-align: center;
    margin-top: 10px;
}

.subheader2 {
    color: var(--md);
    font-size: 15px;
    font-family: DistrictProBold, serif;
    font-weight: 700;
    width: calc(100% - 30px);
    height: 32px;
    text-align: left;
    margin-top: 10px;
    box-shadow: inset 0 -1px 0 0 var(--contrast-1);
}

.colheader {
    color: var(--md);
    font-size: 15px;
    font-family: DistrictProBold, serif;
    font-weight: 700;
    margin-bottom: 5px;
}

.fxwrap {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
}

.md-card-select {
    display: flex;
    align-items: baseline;
    padding-bottom: 20px;
}

.md-card {
    position: fixed;
    z-index: 1000000;
    width: calc(60% - 18px);
    padding-bottom: 10px;
    top: 55px;
    left: 20%;
    right: auto;
    resize: both;
    overflow: hidden;
}

.cb-group {
    display: flex;
    text-align: left;
}

</style>
